"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CosmosValidatorsManager = void 0;
var network_1 = __importDefault(require("../../network"));
var logs_1 = require("@ledgerhq/logs");
var cache_1 = require("../../cache");
var chain_1 = __importDefault(require("./chain/chain"));
var CosmosValidatorsManager = /** @class */ (function () {
    function CosmosValidatorsManager(currency, options) {
        var _this = this;
        this.cacheValidators = (0, cache_1.makeLRUCache)(function () { return __awaiter(_this, void 0, void 0, function () {
            var url, data, validators;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this._endPoint, "/cosmos/staking/").concat(this._version, "/validators?status=BOND_STATUS_BONDED&pagination.limit=175");
                        return [4 /*yield*/, (0, network_1["default"])({
                                url: url,
                                method: "GET"
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        validators = data.validators.map(function (validator) {
                            var commission = parseFloat(validator.commission.commission_rates.rate);
                            return {
                                validatorAddress: validator.operator_address,
                                name: validator.description.moniker,
                                tokens: parseFloat(validator.tokens),
                                votingPower: 0,
                                commission: commission,
                                estimatedYearlyRewardsRate: 0
                            };
                        });
                        return [2 /*return*/, validators];
                }
            });
        }); }, function () { return _this._currency.id; });
        this.getValidators = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cacheValidators()];
                    case 1: 
                    // validators need the rewardsState ONLY to compute voting power as
                    // percentage instead of raw uatoms amounts
                    return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.hydrateValidators = function (validators) {
            (0, logs_1.log)("".concat(_this._currency.id, "/validators"), "hydrate " + validators.length + " validators");
            _this.cacheValidators.hydrate("", validators);
        };
        this._currency = currency;
        this._crypto = (0, chain_1["default"])(currency.id);
        this._endPoint = this._crypto.lcd;
        this._version = this._crypto.version;
        this._minDenom = currency.units[1].code;
        if (options === null || options === void 0 ? void 0 : options.endPoint) {
            this._endPoint = options.endPoint;
            this._minDenom = currency.units[1].code;
        }
        if (options === null || options === void 0 ? void 0 : options.rewardsState) {
            this._rewardsState = options.rewardsState;
        }
    }
    return CosmosValidatorsManager;
}());
exports.CosmosValidatorsManager = CosmosValidatorsManager;
//# sourceMappingURL=CosmosValidatorsManager.js.map